<template>
  <div
    class="upload-id md:tw-w-96 tw-w-11/12 tw-flex tw-flex-col tw-items-center tw-pb-8"
  >
    <OnboardingHeader headerText="Verify your account" />
    <OnboardingSubHeader
      subHeaderText="Upload a Government-Issued ID (International passport, ID card)."
    />
    <form @submit.prevent="uploadIdDocument">
      <div class="tw-relative tw-mb-6">
        <label for="document type"></label>
        <select
          name="documentType"
          id="documentType"
          class="tw-border tw-rounded tw-p-4 tw-pt-3 tw-w-full tw-cursor-pointer focus:tw-border-primary"
          v-model="idDocument.documents[0].name"
          :disabled="idLoading"
          required
        >
          <option value="" selected disabled>Select a document type</option>
          <option value="Passport">International passport</option>
          <option value="national identity card">National ID card</option>
          <option value="Driver’s License">Driver’s License</option>
          <option value="voter's card">Voter’s Card</option>
        </select>
      </div>
      <DragNDrop
        accept="image/png,image/jpeg,image/jpg,.pdf"
        :currentValue="idDocument.documents[0].url"
        :startUpload="uploadIdDoc"
        @re-upload="uploadIdDoc = false"
        @upload-complete="submitIdDocument"
        @upload-error="idUploadError"
      >
        <p
          class="tw-text-sm tw-text-secondary tw-w-full tw-text-center tw-mb-2"
        >
          Drop JPEG, PNG or PDF file here to upload
        </p>
      </DragNDrop>
      <div class="btn-container tw-flex">
        <router-link
          type="button"
          class="tw-border tw-block tw-rounded tw-text-sm tw-text-secondary-dark tw-bg-gray-light tw-px-2 tw-py-4 tw-text-center"
          :to="{ name: 'UploadDocument' }"
        >
          Skip this step
        </router-link>
        <button
          class="tw-bg-primary tw-rounded tw-text-sm tw-text-white tw-px-2 tw-py-4"
        >
          <span v-if="!idLoading">Submit</span>
          <img
            v-show="idLoading"
            class="tw-m-auto"
            src="@/assets/img/spinner.svg"
            alt="animated spinner"
          />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader.vue";
  import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader.vue";
  import OnboardingBtn from "@/components/onboarding/OnboardingBtn.vue";
  import DragNDrop from "@/components/general/DragNDrop";
  import { getItem } from "@/utils/storage.js";

  export default {
    name: "UploadId",

    components: {
      OnboardingHeader,
      OnboardingSubHeader,
      DragNDrop,
      OnboardingBtn,
    },

    data() {
      return {
        idLoading: false,
        idDocument: {
          documents: [
            {
              name: "",
              url: "",
              type: "identification",
            },
          ],
        },
        uploadIdDoc: false,
      };
    },

    methods: {
      ...mapActions("organisationModule", ["submitKycDocument"]),
      ...mapActions(["showToast"]),

      async submitIdDocument(url) {
        this.idDocument.documents[0].url = url;
        const response = await this.submitKycDocument(this.idDocument);
        if (response) {
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.$router.push({ name: "UploadDocument" });
        }
        this.idLoading = false;
        this.uploadIdDoc = false;
      },

      idUploadError() {
        this.idLoading = false;
        this.uploadIdDoc = false;
      },

      uploadIdDocument() {
        this.idLoading = true;
        this.uploadIdDoc = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .upload-id {
    .btn-container {
      display: grid;
      grid-template-columns: 0.7fr 1fr;
      column-gap: 1rem;
    }
    @media (min-width: 768px) {
      width: 440px;
    }
  }
</style>
